// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f88d07f7","453":"94315750","455":"5eb5a699","977":"1021dfd5"}[chunkId] + ".chunk.js";
};